// extracted by mini-css-extract-plugin
export default {"container":"MfuMfA37mrcuHD1kdFaf","image":"DC6Xnj21dGPBINfHqFAl","content":"fH3WZOZNqory999QN1hn","title":"etM76tTpBK6lwBvPwWZQ","wegoIconContainer":"jXyIdGbHc7b6dsksY8Oj"};